var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoHelpMobileBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,0C36.7,0,24,5.3,14.6,14.6S0,36.7,0,50s5.3,26,14.6,35.4S36.7,100,50,100s26-5.3,35.4-14.6S100,63.3,100,50 s-5.3-26-14.6-35.4S63.3,0,50,0z M50,76.4l-0.5,0.1h-1c-0.3-0.1-0.6-0.1-0.9-0.2c-2.7-0.7-4.5-3.4-4.1-6.2c0.4-2.8,2.9-4.8,5.7-4.7 c2.8,0.1,5.1,2.3,5.3,5.1C54.8,73.4,52.8,75.9,50,76.4L50,76.4z M66,40.1c-0.6,1.8-1.6,3.5-2.9,4.9c-1.5,1.5-3.2,2.9-5,4.1 c-1,0.7-1.9,1.4-2.8,2.1l0,0c-0.9,0.7-1.5,1.6-1.8,2.7c-0.2,0.5-0.4,1.1-0.6,1.6c-0.6,1.5-2,2.5-3.6,2.5c-0.9,0.1-1.7,0-2.5-0.4 c-1.2-0.6-2.1-1.8-2.3-3.1c-0.3-1.9,0.1-3.8,1.2-5.3c0.9-1.3,1.9-2.4,3.1-3.3c1.3-1.1,2.7-2.1,4-3.2c1.1-0.9,2-1.9,2.7-3.1 c1.1-2.1,0.8-4.7-0.7-6.5c-0.8-0.9-1.8-1.4-3-1.7c-1.5-0.4-3.1-0.3-4.7,0.1c-1.6,0.4-2.9,1.5-3.6,3c-0.5,0.9-0.9,1.8-1.3,2.7 C42,37.9,41.5,38.5,41,39c-0.9,0.8-2.2,1.2-3.4,1.1c-0.8,0-1.5-0.2-2.1-0.6c-1.2-0.6-2-1.9-2-3.3c-0.1-2.2,0.7-4.4,2-6.1 c1.6-2.1,3.6-3.8,6-4.9c1.8-0.9,3.7-1.4,5.7-1.6l1.1-0.1h2l1.1,0.1l0,0c2.7,0.2,5.3,0.8,7.7,2c2.2,1,4,2.6,5.3,4.6 c1,1.6,1.6,3.3,1.8,5.2C66.5,36.9,66.4,38.5,66,40.1L66,40.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHelpMobileBlack);
export default __webpack_public_path__ + "static/media/ico-help-mobile-black.20bbcb6c8b00b1a8741af74e3ba8b485.svg";
export { ForwardRef as ReactComponent };